<div mat-dialog-title><mat-icon class="title align-middle">group</mat-icon>{{ dialogTitle | translate:locale.language }}</div>
<div mat-dialog-content>
  @if (group) {
    @if (group.name) {
      <div id="group-name" class="row-item">
        <span class="summary-label"><mat-icon>group</mat-icon>{{ 'Name' | translate:locale.language}}:</span>
        <div>{{ group.name }}</div>
      </div>
    }
    @if (group.classification) {
      <div id="group-type" class="row-item">
        <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ 'Type' | translate:locale.language}}:</span>
        <div>{{ group.classification }}</div>
      </div>
    }
    @if (group.isLinked) {
      <div id="group-link" class="row-item">
        <span class="summary-label"><mat-icon>link</mat-icon>{{ 'Linked' | translate:locale.language}}:</span>
        <div>Yes</div>
      </div>
    }
    <div id="group-children" class="row-item">
      <span class="summary-label"><mat-icon>groups</mat-icon>{{ 'Child Groups' | translate:locale.language}}:</span>
      <div>{{ !!group.children ? group.children : ('None' | translate:locale.language) }}</div>
    </div>
    <div id="group-members" class="row-item">
      <span class="summary-label"><mat-icon>contacts</mat-icon>{{ 'Members' | translate:locale.language}}:</span>
      <div>{{ !!group.members ? group.members : ('None' | translate:locale.language) }}</div>
    </div>
    @if (!!group.children) {
      <div id="group-total-members" class="row-item">
        <span class="summary-label" matTooltip="{{ 'includes nested group members' | translate:locale.language }}">
          <mat-icon>contacts</mat-icon>{{ 'Total Members' | translate:locale.language}}:
        </span>
        @if (!!contacts) {
          <div>{{ contacts?.totalItemCount }}</div>
        } @else {
          <app-loading [isInline]="true" [diameter]="22"></app-loading>
        }
      </div>
    }
  } @else {
    <div class="row">
      <app-loading [hasFailed]="!!loadError" [failTitle]="loadError" [hideRetry]="hideRetry" (retryClicked)="loadGroup()"></app-loading>
    </div>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" id="closeGroup" (click)="closeDialogs()">{{ 'Close' | translate:locale.language }}</button>
</div>